import { t } from '@lingui/macro';
import { getCustomerSummaryRollup } from 'api/api';
import isEmpty from 'lodash/isEmpty';
import Button from 'MUI_Kit/components/CustomButtons/Button';
import PropTypes from 'prop-types';
import React, { memo, useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useApi } from '../../../hook/utils';
import { chartsDateRangeSelector } from '../utils';
import InsightStatisticCard from './InsightStatisticCard';

const getSummaryContent = (data) => {
  if (!data || typeof data !== 'object' || Array.isArray(data)) return '';
  return data.content || '';
};

const CustomerSummaryRollup = (props) => {
  const { getApi = getCustomerSummaryRollup, title = t`Tổng lược`, canDelete, code } = props;
  const { since, until } = useSelector(chartsDateRangeSelector());
  const { loading, doFetch } = useApi();
  const [summaryContent, setSummaryContent] = useState('');
  const [error, setError] = useState({});

  useEffect(() => {
    setSummaryContent('');
    setError({});
  }, [since, until]);

  const fetchSummary = useCallback(async () => {
    if (!since || !until) return;
    setError({});
    const { error, data, ...rest } = await doFetch(getApi({ since, until }));
    if (error) setError({ error, ...rest });
    else setSummaryContent(getSummaryContent(data));
  }, [since, until, doFetch, getApi]);

  const hasContent = Boolean(summaryContent && String(summaryContent).trim());

  const emptyContent = (
    <Button color="info" onClick={fetchSummary} loading={loading}>
      <i className="fal fa-sparkles" style={{ marginRight: 8 }} />
      {t`THỰC HIỆN`}
    </Button>
  );

  return (
    <InsightStatisticCard
      title={title}
      canDelete={canDelete}
      code={code}
      error={error}
      showEmpty={!hasContent}
      emptyContent={isEmpty(error) ? emptyContent : undefined}>
      <div
        style={{
          fontWeight: 400,
          fontSize: 12,
          lineHeight: '16px',
          whiteSpace: 'pre-wrap',
          textAlign: 'left',
          width: '100%',
        }}>
        {summaryContent}
      </div>
    </InsightStatisticCard>
  );
};

CustomerSummaryRollup.propTypes = {
  getApi: PropTypes.func,
  title: PropTypes.string,
  canDelete: PropTypes.bool,
  code: PropTypes.string,
};

export default memo(CustomerSummaryRollup);
